import { Outlet } from "react-router-dom";

const Program = () => {

  return <Outlet />
}

export default Program;